// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"036eefa4","977":"c4b9ea4c"}[chunkId] + ".chunk.js";
};